import { Accordion, Link, List, Stack, Text } from "basis";
import { Question } from "./Question";

function Support({ initiallyOpen }) {
  return (
    <Accordion.Item initiallyOpen={initiallyOpen}>
      <Accordion.Item.Header>Support</Accordion.Item.Header>
      <Accordion.Item.Content>
        <Stack gap="10">
          <Question
            title="Can I close my credit card account in the Latitude Service Centre?"
            productType="credit-card"
            region="AU"
          >
            <Text>
              You can send us a request to close your account by selecting your
              account from the Home page. Then go to Manage Account and choose
              Close Account from the menu.
            </Text>
          </Question>
          <Question
            title="Can I reduce my Credit Limit on my credit card account in the Latitude Service Centre?"
            productType="credit-card"
            region="AU"
          >
            <Text>
              You can send us a request to reduce your credit limit by selecting
              your account from the Home page. Then go to Manage Account and
              choose Reduce Credit Limit from the menu.
            </Text>
          </Question>
          <Question
            title="Which Australian credit cards are supported by the Latitude Service Centre?"
            productType="credit-card"
            region="AU"
          >
            <List>
              <List.Item>
                Latitude 28 Degrees Global Platinum Mastercard
              </List.Item>
              <List.Item>Latitude Infinity Rewards Visa</List.Item>
              <List.Item>Latitude Low Rate Mastercard</List.Item>
              <List.Item>Latitude Gem Visa</List.Item>
              <List.Item>GO Mastercard</List.Item>
              <List.Item>AFS Creditline</List.Item>
              <List.Item>Latitude Mastercard</List.Item>
              <List.Item>Latitude Eco Mastercard</List.Item>
              <List.Item>Creditline</List.Item>
              <List.Item>Buyers Edge</List.Item>
              <List.Item>Care Credit</List.Item>
            </List>
          </Question>
          <Question
            title="Which New Zealand credit cards are supported?"
            productType="credit-card"
            region="NZ"
          >
            <List>
              <List.Item>Gem Visa</List.Item>
              <List.Item>Gem Creditline</List.Item>
              <List.Item>Gem Essential (Formerly Onecard Visa)</List.Item>
            </List>
          </Question>
          <Question title="How do I contact Latitude?">
            <Text>
              You can find our contact details on the{" "}
              <Link href="/contact" newTab={false}>
                Contact us
              </Link>{" "}
              page.
            </Text>
          </Question>
          <Question
            title="How do I report my card is lost or stolen to Latitude?"
            productType="credit-card"
          >
            <Text>
              You can call us 24 hours a day, 7 days a week to report your card
              lost or stolen. Head to our Support page for the contact number.
            </Text>
          </Question>
          <Question
            title="Why am I on a Latitude page when I have a Gem Finance product?"
            region="NZ"
          >
            <Text>
              Gem Finance is a part of the Latitude Financial Services group.
              You can link all of your New Zealand Gem products in the Latitude
              Service Centre and Latitude App.
            </Text>
          </Question>
          <Question title="Can I still use OSC?">
            <Text>
              Yes, you can continue to use the Online Service Centre for now.
              Eventually the Online Service Centre will be decommissioned, but
              only after the Latitude Service Centre offers all the same
              features (and more!).
            </Text>
          </Question>
        </Stack>
      </Accordion.Item.Content>
    </Accordion.Item>
  );
}

export { Support };
